
import React from "react";
import { Helmet } from "react-helmet";
import LazyLoad from "react-lazyload";
import Card from "../../components/Card";
import CardSection from "../../components/CardSection";
import americorps from "../../assets/images/who-we-are/americorps.webp";
import careers from "../../assets/images/who-we-are/careers.webp";

const CareerOpportunities = () => {
  const opportunities = [
    {
      title: "Job Opportunities",
      description:
        "We appreciate your interest in working with Habitat Buffalo to make the dream of affordable housing in Western New York a reality.",
      link: "/jobs/job-listings",
      image: careers,
      buttonText: "Apply Here",
    },
    {
      title: "AmeriCorps Opportunities",
      description:
        "Join our team through AmeriCorps and make a difference in your community.",
      link: "/jobs/americorps-listings",
      image: americorps,
      buttonText: "Read More",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Career Opportunities - Habitat for Humanity Buffalo</title>
        <meta
          name="description"
          content="Join Habitat for Humanity Buffalo and help make affordable housing a reality. Explore our job and AmeriCorps opportunities."
        />
      </Helmet>
      <div className="container text-center">
        <h1>Career Opportunities</h1>
        <h2 className="section-header primary">
          Join us and Make a Difference!
        </h2>
        <p>
          We appreciate your interest in working with Habitat Buffalo to make
          the dream of affordable housing in Western New York a reality. Please
          click below for more information on our available positions:
        </p>
        <CardSection>
          {opportunities.map((opportunity, index) => (
            <LazyLoad key={index} height={200} offset={100}>
              <Card
                title={opportunity.title}
                description={opportunity.description}
                link={opportunity.link}
                image={opportunity.image}
                buttonText={opportunity.buttonText}
              />
            </LazyLoad>
          ))}
        </CardSection>
      </div>
    </>
  );
};

export default CareerOpportunities;
